var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mt-4 mb-4 d-flex justify-content-center",attrs:{"cols":"12","md":"12","lg":"12"}},[_c('StreamBarcodeReader',{ref:"scanner",on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded,"init":_vm.onInit,"error":_vm.onError}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }